import styles from './style/EnterpriseList.module.scss';
import InnerLayout from '../Layout/InnerLayout';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../Utilities/PaginationNew';
import {
  selectEnterpriseCompany,
  getPersonalLists,
  getHistoryStartOne,
  getUserLists,
  upgradePersonalToEnterprise,
} from "../../store/slice/manager/enterpriseCompany";
import Modal from "../Utilities/Modal";
import { selectPermissionSettings } from "../../store/slice/permissionSettings";
import EmptyBox from "../Utilities/EmptyBox";
import LoadingTable from "../Utilities/LoadingTable";
import Button from "../Utilities/Button";
import Tips from "../Utilities/Tips";
import InputSearch from "../Utilities/InputSearch";
import moment from "moment";
import { FiCheck, FiArrowUp, FiArrowDown } from "react-icons/fi";
import { AiOutlineSetting } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import TextField from "../Utilities/TextField";
import { RiHistoryLine } from "react-icons/ri";
import ModalHistoryStartOne from "./ModalHistoryStartOne";
import Tabs from "../Utilities/Tabs";
import { BiExport } from 'react-icons/bi';
import { getDownloadUsers } from '../../store/slice/workspaceList';
import Dropdown from "../Utilities/DropdownDynamic";
import PersonalManagePlanModal from "./PersonalManagePlanModal";

// 「購買方案」藥丸計數：以 /api/software-services（menu）為母體，逐一比對 user.subscribed_services。
// menu 未載入時退回只計算已訂閱服務（與 EnterpriseList 一致）。
const bucketSubscription = (sub, counts) => {
  const valid =
    sub?.expiration_date &&
    !moment(sub.expiration_date).isBefore(moment(), "day");
  if (!valid) counts.off += 1;
  else if (sub.is_trial === 1 || sub.is_trial === true) counts.trial += 1;
  else counts.active += 1;
};

const getPlanCounts = (services, menu) => {
  const subs = Array.isArray(services) ? services : [];
  const counts = { active: 0, trial: 0, off: 0 };
  if (Array.isArray(menu) && menu.length > 0) {
    menu
      .filter((svc) => svc?.status !== false)
      .forEach((svc) => {
        const sub = subs.find((s) => s.service_id === svc.id);
        bucketSubscription(sub, counts);
      });
  } else {
    subs.forEach((s) => bucketSubscription(s, counts));
  }
  return counts;
};

const PersonalList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { lists, loading, permission_error, users_topup } = useSelector(selectEnterpriseCompany);
  const { auth, permissions } = useSelector(selectPermissionSettings);

  const limit = 20;
  const [manageUser, setManageUser] = useState(null); // 開啟「管理方案」彈窗的個人帳號
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchSearchValue, setFetchSearchValue] = useState('');
  const [page, setPage] = useState(0);
  const [settingsModal, setSettingsModal] = useState(null); // 開啟「升級為企業戶」彈窗的個人帳號
  const [upgradeCompany, setUpgradeCompany] = useState('');
  const [upgradeTaxId, setUpgradeTaxId] = useState('');
  const [upgradeError, setUpgradeError] = useState('');
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [invoiceFilter, setInvoiceFilter] = useState('全部');
  const [sortBy, setSortBy] = useState('email_verified_at');
  const [order, setOrder] = useState('desc');
  const [tabValue, setTabValue] = useState(0);

  const tabList = ['START-ONE'];
  const invoiceOptions = ['全部', '未開發票', '已開發票', '未購買'];

  const getInvoiceValue = (label) => {
    switch (label) {
      case '未開發票': return 'uninvoiced';
      case '已開發票': return 'invoiced';
      case '未購買': return 'unpurchased';
      default: return '';
    }
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setOrder('desc');
    }
    setPage(0);
  };

  useEffect(() => {
    dispatch(
      getPersonalLists({
        page: page + 1,
        rows: limit,
        search: fetchSearchValue,
        invoice_status: getInvoiceValue(invoiceFilter),
        sort: sortBy,
        sort_method: order,
      })
    );
  }, [dispatch, page, fetchSearchValue, invoiceFilter, sortBy, order]);

  const handlePageChange = (e) => {
    setPage(parseInt(e));
    dispatch(
      getPersonalLists({
        page: e,
        rows: limit,
        search: fetchSearchValue,
        invoice_status: getInvoiceValue(invoiceFilter),
        sort: sortBy,
        sort_method: order,
      })
    );
  };

  const handleOpenSettings = (data) => {
    setSettingsModal({ user: data });
    setUpgradeCompany('');
    setUpgradeTaxId('');
    setUpgradeError('');
  };

  const handleCloseSettings = () => {
    setSettingsModal(null);
    setUpgradeCompany('');
    setUpgradeTaxId('');
    setUpgradeError('');
  };

  const handleUpgradeToEnterprise = () => {
    if (!upgradeCompany.trim()) { setUpgradeError('公司名稱為必填欄位'); return; }
    setUpgradeLoading(true);
    dispatch(
      upgradePersonalToEnterprise({
        user_id: settingsModal?.user?.id,
        title: upgradeCompany.trim(),
        taxid: upgradeTaxId.trim(),
      })
    ).then((e) => {
      setUpgradeLoading(false);
      if (e.payload?.status === 201 || e.meta?.requestStatus === 'fulfilled') {
        handleCloseSettings();
        navigate('/admin/company-system');
      } else {
        setUpgradeError(e.payload?.message || '升級失敗，請稍後再試');
      }
    });
  };

  const handleGiftHistory = (data) => {
    setIsOpen(data);
    const postObj = {
      user_id: data?.user_information?.user_id,
      page: 1,
      limit: 10,
    };
    dispatch(getHistoryStartOne(postObj));
  };

  useEffect(() => {
    dispatch(
      getUserLists({
        limit: 99999,
        page: 1,
      })
    );
  }, [dispatch]);

  const findTopUpForUser = (user) => {
    const list = users_topup?.users || [];
    if (!list || list.length === 0) return null;

    // Try matching by user id, nested user_information.user_id, or email
    const byId = list.find((u) => u?.id === user?.id || u?.user_id === user?.id);
    if (byId) return byId;

    const byNestedId = list.find((u) => u?.user_information?.user_id === user?.id);
    if (byNestedId) return byNestedId;

    const byEmail = list?.find((u) => u?.email?.trim().toLowerCase() === user?.email?.trim().toLowerCase());

    if (byEmail) return byEmail;
    return null;
  };

  const getTopUpValue = (topUp, keys) => {
    if (!topUp) return null;
    for (const k of keys) {
      if (topUp[k] !== undefined && topUp[k] !== null) return topUp[k];
    }
    return null;
  };

  return (
    <InnerLayout>
      <ModalHistoryStartOne
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        findTopUpForUser={findTopUpForUser}
        getTopUpValue={getTopUpValue}
        refreshPersonalList={() => {
          dispatch(
            getPersonalLists({
              page: page + 1,
              rows: limit,
              search: fetchSearchValue,
              invoice_status: getInvoiceValue(invoiceFilter),
              sort: sortBy,
              sort_method: order,
            })
          );
        }}
      />

      {/* Settings Modal */}
      <Modal isOpen={!!settingsModal} size='sm' width='500px' height='auto'>
        <div style={{ padding: '4px 0' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, paddingBottom: 14, borderBottom: '1px solid #f3f4f6' }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: '.85rem', flexShrink: 0 }}>
              {settingsModal?.user?.name?.charAt(0)?.toUpperCase()}
            </div>
            <div>
              <p style={{ fontWeight: 700, fontSize: '.88rem', color: '#111827', margin: 0 }}>{settingsModal?.user?.name}</p>
              <p style={{ fontSize: '.75rem', color: '#9ca3af', margin: 0 }}>{settingsModal?.user?.email}</p>
            </div>
            <button
              onClick={handleCloseSettings}
              style={{ marginLeft: 'auto', width: 28, height: 28, borderRadius: 6, border: '1px solid #e5e7eb', background: '#f9fafb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
            >
              <MdClear size={14} color='#6b7280' />
            </button>
          </div>

          <div style={{ fontWeight: 700, fontSize: '.86rem', color: '#111827', marginBottom: 16 }}>
            升級為企業戶
          </div>

          <div>
            <div style={{ background: '#f5f3ff', border: '1px solid #ede9fe', borderRadius: 10, padding: '12px 14px', marginBottom: 18, fontSize: '.78rem', color: '#6d28d9', lineHeight: 1.6 }}>
              升級後此帳號將取得企業帳號功能，並可使用任務管理、績效管理等企業功能。
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: '.78rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
                公司名稱 <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <TextField
                placeholder='請輸入公司或組織名稱...'
                width='100%'
                value={upgradeCompany}
                onChange={(e) => { setUpgradeCompany(e); setUpgradeError(''); }}
                error={!!upgradeError && !upgradeCompany.trim()}
              />
              {upgradeError && <p style={{ fontSize: '.72rem', color: '#ef4444', marginTop: 4 }}>{upgradeError}</p>}
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: '.78rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
                統一編號
                <span style={{ marginLeft: 8, fontSize: '.7rem', color: '#9ca3af', fontWeight: 400 }}>(非必填)</span>
              </label>
              <TextField
                placeholder='請輸入統一編號...'
                width='100%'
                value={upgradeTaxId}
                onChange={(e) => setUpgradeTaxId(e)}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <Button title='取消' type='secondary' onClick={handleCloseSettings} />
              <Button title={upgradeLoading ? '處理中...' : '確認升級為企業戶'} type='primary' onClick={handleUpgradeToEnterprise} disabled={upgradeLoading} />
            </div>
          </div>
        </div>
      </Modal>

      <div className={styles.dashboard}>
        <div className={styles.dashboardBusinessRight}>
          <div className={styles.dashboardTitle}>個人帳號管理</div>

          {auth?.roles?.find((item) => item.includes("workspace.admin")) ||
            (auth?.workspace_permissions?.length > 0 &&
              permissions?.find((item) =>
                item.includes("enterprise.view_enterprise_list")
              ) &&
              !permission_error) ? (
            <>
              <div className={styles.dashboardListContainer}>
                <div className={styles.dashboardListTitle}>
                  <Tabs values={tabList} onChange={(e) => setTabValue(e.tabIndex)} selectedIndex={tabValue} />
                </div>
                <div className={styles.searchBar}>
                  <div className={styles.dropdownWrapper} style={{ display: 'block', width: '130px' }}>
                    <Dropdown
                      placeholder='發票狀態'
                      value={invoiceFilter}
                      listItems={invoiceOptions}
                      onChange={(e) => {
                        setInvoiceFilter(e);
                        setPage(0);
                      }}
                    />
                  </div>
                  <div
                    className={styles.btn}
                    onClick={() => {
                      dispatch(getDownloadUsers());
                    }}
                  >
                    <BiExport fontSize={20} />
                    匯出
                  </div>
                  <InputSearch
                    disabled={fetchSearchValue === '' && lists?.users_count === 0}
                    placeholder='搜尋Email或姓名'
                    value={searchTerm}
                    onKeyPress={(e) => {
                      if ((e.code === 'Enter' || e.charCode === 13) && !loading) {
                        setFetchSearchValue(searchTerm);
                        setPage(0);
                      }
                    }}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    clickSearchIcon={() => {
                      if (!loading) {
                        setFetchSearchValue(searchTerm);
                        setPage(0);
                      }
                    }}
                    onClear={() => {
                      setSearchTerm('');
                      setFetchSearchValue('');
                      setPage(0);
                    }}
                    width={'230px'}
                    height={'22px'}
                  />
                </div>
              </div>

              {tabValue === 0 && (
                <div className={styles.tableContainer}>
                  {lists?.users?.length > 0 && (
                    <div
                      className={styles.paginationContainer}
                      style={{ paddingTop: 0, paddingBottom: 8 }}>
                      <Pagination
                        onPageChange={(e) => {
                          setPage(parseInt(e.selected));
                        }}
                        pageCount={page + 1}
                        totalData={lists?.users_count}
                        onInputChange={handlePageChange}
                        totalPages={Math.ceil(lists?.users_count / limit)}
                        limit={limit}
                      />
                    </div>
                  )}
                  <table>
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>姓名</th>
                        <th style={{ minWidth: '110px' }}>驗證</th>
                        <th style={{ minWidth: '170px' }}>購買方案</th>
                        {/* <th>註冊平台</th> */}
                        <th>設定</th>
                        <th 
                          style={{ cursor: 'pointer', userSelect: 'none' }}
                          onClick={() => handleSort('email_verified_at')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            建立日期
                            {sortBy === 'email_verified_at' && (
                              order === 'asc' ? <FiArrowUp /> : <FiArrowDown />
                            )}
                          </div>
                        </th>
                        <th style={{ minWidth: '100px' }}>發票狀態</th>
                        <th>儲值金 (剩餘/已用)</th>
                        <th>贈送金 (剩餘/已用)</th>
                        <th style={{ minWidth: '30px' }}></th>
                      </tr>
                    </thead>
                    {loading ? (
                      <LoadingTable row={10} column={10} />
                    ) : (
                      <>
                        {lists?.users?.length > 0 ? (
                          <tbody>
                            {lists?.users?.map((data, i) => (
                              <React.Fragment key={i}>
                                <tr>
                                  <td className={styles.tableTd}>
                                    <div className={styles.wrap}>{data.email}</div>
                                  </td>
                                  <td className={styles.tableTd}>{data.name}</td>
                                  <td className={styles.tableTd}>
                                    {data.email_verified_at ? (
                                      <Tips detail={`${moment(data.email_verified_at).format('YYYY/MM/DD')} Email已驗證`} topDiff={3} leftDiff={20}>
                                        <Button
                                          type='primary'
                                          small
                                          title={'已驗證'}
                                          icon={<FiCheck className={styles.emailVerified} />}
                                          color={'#34C759'}
                                        />
                                      </Tips>
                                    ) : (
                                      <Tips detail={`個人帳號未驗證`} topDiff={3} leftDiff={33}>
                                        <Button type='primary' title={'未驗證'} color={'#cccccc'} />
                                      </Tips>
                                    )}
                                  </td>

                                  {/* 購買方案：被綁在企業帳號下者，顯示所屬企業並可點擊前往企業管理頁（方案由企業端管理） */}
                                  <td className={styles.tableTd}>
                                    {data.enterprise ? (
                                      data.enterprise_id ? (
                                        <button
                                          type='button'
                                          onClick={() =>
                                            navigate('/admin/company-system', {
                                              state: {
                                                openEnterprise: {
                                                  enterprise_id: data.enterprise_id,
                                                  enterprise_name: data.enterprise_title,
                                                  tax_id: data.enterprise_taxid,
                                                },
                                              },
                                            })
                                          }
                                          style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, border: 'none', background: 'none', padding: 0, cursor: 'pointer', textAlign: 'left' }}
                                        >
                                          <span style={{ color: '#7c3aed', fontSize: 13, fontWeight: 600 }}>
                                            {data.enterprise_title || '所屬企業'}
                                          </span>
                                          <span style={{ color: '#86868b', fontSize: 12 }}>
                                            由所屬企業管理 ›
                                          </span>
                                        </button>
                                      ) : (
                                        <span style={{ color: '#86868b', fontSize: 13 }}>
                                          由所屬企業管理
                                        </span>
                                      )
                                    ) : (
                                      (() => {
                                        // 個人帳號只計其實際擁有的方案（不以全服務清單為母體，避免未啟用被灌大）
                                        const c = getPlanCounts(data.subscribed_services);
                                        return (
                                          <div className={styles.planSummary}>
                                            <div className={styles.statusPills}>
                                              <div className={`${styles.pill} ${styles.pillActive}`}>
                                                <span className={styles.dot} />
                                                已啟用 <span className={styles.pillCount}>{c.active}</span>
                                              </div>
                                              <div className={`${styles.pill} ${styles.pillTrial}`}>
                                                <span className={styles.dot} />
                                                試用中 <span className={styles.pillCount}>{c.trial}</span>
                                              </div>
                                              <div className={`${styles.pill} ${styles.pillOff}`}>
                                                <span className={styles.dot} />
                                                未啟用 <span className={styles.pillCount}>{c.off}</span>
                                              </div>
                                            </div>
                                            <button
                                              type='button'
                                              className={styles.manageBtn}
                                              onClick={() => setManageUser(data)}
                                            >
                                              <AiOutlineSetting /> 管理方案
                                            </button>
                                          </div>
                                        );
                                      })()
                                    )}
                                  </td>

                                  <td className={styles.tableTd}>
                                    <Tips detail={data.enterprise ? '已為企業帳號' : '升級企業帳號'}>
                                      <Button
                                        type='pure'
                                        icon={<AiOutlineSetting />}
                                        disabled={!!data.enterprise}
                                        onClick={() => handleOpenSettings(data)}
                                      />
                                    </Tips>
                                  </td>
                                  <td className={styles.tableTd}>{data.email_verified_at}</td>
                                  <td className={styles.tableTd}>
                                    <span className={
                                      data.invoice_status === 'unpurchased' ? styles.tagUnpurchased :
                                        data.invoice_status === 'uninvoiced' ? styles.tagGrey : styles.tagGreen
                                    }>
                                      {data.invoice_status === 'unpurchased' ? '未購買' :
                                        data.invoice_status === 'uninvoiced' ? '未開發票' : '已開發票'}
                                    </span>
                                  </td>
                                  <td className={styles.tableTd}>
                                    {data.topUpCredits ? (
                                      <label style={{ color: "#34C759" }}>
                                        {`NT$ ${(data.topUpCredits).toLocaleString("zh-TW", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })}`}
  
                                      </label>) :
                                      <label style={{ color: "#34C759" }}>NT$ 0</label>}
                                      <br />
                                      {data.usedTopUpCredits ? (
                                      <label style={{ color: "#666666" }}>
                                        {`NT$ ${(data.usedTopUpCredits).toLocaleString("zh-TW", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })}`}
  
                                      </label>) :
                                      <label style={{ color: "#888888" }}>NT$ 0</label>}
                                  </td>
                                  <td className={styles.tableTd}>
                                    {data.giftedCredits ? (
                                      <label style={{ color: "#AF52DE" }}>
                                        {`NT$ ${(data.giftedCredits).toLocaleString("zh-TW", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })}`}
  
                                      </label>) :
                                      <label style={{ color: "#AF52DE" }}>NT$ 0</label>}
                                      <br />
                                      {data.usedGiftedCredits ? (
                                      <label style={{ color: "#888888" }}>
                                        {`NT$ ${(data.usedGiftedCredits).toLocaleString("zh-TW", {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        })}`}
  
                                      </label>) :
                                      <label style={{ color: "#888888" }}>NT$ 0</label>}
                                  </td>
                                  <td className={`${styles.dropLists} ${styles.tableTd}`}>
                                    <div className={styles.actionWrapper}>
                                      {(auth?.roles?.find((item) =>
                                        item.includes("workspace.admin")
                                      ) ||
                                        permissions?.includes(
                                          "tdp.services.enterprise.stop_services_enterprise_bought.center"
                                        )) && (
                                          <div>
                                            <Tips detail='查看紀錄'>
                                              <Button
                                                type='pure'
                                                icon={<RiHistoryLine />}
                                                onClick={() =>
                                                  handleGiftHistory(data)
                                                }
                                              />
                                            </Tips>
                                          </div>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan={10}>
                                <EmptyBox caption={fetchSearchValue ? '目前尚無搜尋結果' : '目前沒有個人帳號'} />
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </>
                    )}
                  </table>
                  {lists?.users?.length > 0 && (
                    <div className={styles.paginationContainer}>
                      <Pagination
                        onPageChange={(e) => {
                          setPage(parseInt(e.selected));
                        }}
                        pageCount={page + 1}
                        totalData={lists?.users_count}
                        onInputChange={handlePageChange}
                        totalPages={Math.ceil(lists?.users_count / limit)}
                        limit={limit}
                      />
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className={styles.tableContainer}>
              <EmptyBox caption={'您沒有權限'} />
            </div>
          )}
        </div>
      </div>

      {/* 管理方案（後台開通/試用，不扣款）；被綁企業者不會開到（列表已隱藏按鈕） */}
      <PersonalManagePlanModal
        isOpen={!!manageUser}
        user={manageUser}
        onClose={() => setManageUser(null)}
        onChanged={() => {
          dispatch(
            getPersonalLists({
              page: page + 1,
              rows: limit,
              search: fetchSearchValue,
              invoice_status: getInvoiceValue(invoiceFilter),
              sort: sortBy,
              sort_method: order,
            })
          );
        }}
      />
    </InnerLayout>
  );
};

export default PersonalList;
